module.exports = __webpack_public_path__ + "media/images/defaults/citizen_science_project_image/slider-53a4dffb96ecad1a06ca3f609702ce54.png";